import { CREATEINVOICE_SUCCESS, CREATEINVOICE_FAIL } from "../actionTypes";

const initialState = {
    user: [],
};

const createInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATEINVOICE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload,
            };
        case CREATEINVOICE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default createInvoiceReducer;
